/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout wrap>
      <v-container fluid grid-list-md text-xs-center pa-4>
        <v-layout row wrap>
          <v-flex xs6 sm6 md4 lg3 v-for="(item, idx) in items" :key="'B' + idx">
            <Card class="ana-card">
              <div @click="item.component!= 'plant_static_info' ? $router.push(`${item.path}`) : myFunction()" class="mt-2">
                <img
                  class="card-icon"
                  :src="requireImage(item.path)"
                  alt="enerman logo"
                />
                <div class="ana-card-text">{{item.name}}</div>
              </div>
            </Card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from "@/components/static-info/CustomCard.vue"

export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      componentKey: 0
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getRules', 'getActivePlantInfo'])
  },
  mounted() {
    const pathModule = this.$router.currentRoute.path.split('/')[2]
    this.getComponents(pathModule)
  },
  methods: {
    // Open New Window To Display PDF
    myFunction: function() {
      window.open(this.getActivePlantInfo('staticInfo'))
    },
    requireImage(name) {
      try {
        return require(`../assets/devices${name}.svg`);
      } catch (error) {
        return require('../assets/devices/plantdetail.svg');
      }
    },
    getComponents(pathModule) {
      const accessModule = this.getRules(['rule', 'access_config', `${pathModule}`])
      accessModule && Object.keys(accessModule).length > 1 ? (this.items = accessModule) : this.$router.push(accessModule[0].path)
      this.componentKey += 1
    }
  },
  watch: {
    $route(to, from) {
      const pathModule = to.path.split('/')[2]
      this.getComponents(pathModule)
    },
    getSelectedPlantId() {
      const pathModule = this.$router.currentRoute.path.split('/')[2]
      this.getComponents(pathModule)
    }
  }
}
</script>

<style scoped>
.ana-card {
  cursor: pointer;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.ana-card-text {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.card-icon {
  width: 37px;
  height: 40px;
}

@media (max-width: 600px) {
  .ana-card{
    padding: 10px;
    margin-top: 10px;
  }
}

@media (max-width:400px) {
  .ana-card-text {
    font-size: 14px;
    }

  .card-icon {
    width: 20px;
    height: 25px;
  }
}

.theme--dark .card-icon {
  filter: invert(100%) sepia(0%) saturate(7478%) hue-rotate(113deg) brightness(92%) contrast(119%);
}

.theme--light .card-icon {
  filter: invert(48%) sepia(12%) saturate(463%) hue-rotate(179deg) brightness(98%) contrast(86%);
}
</style>
